import React from 'react';
import NumberElement from './Number';
import WrapComponent from '../WrapComponent';

class Percentile extends React.PureComponent{
    render(){
        let props = this.props;
        let { decimal_places, auto_adapt_places } = props
        let appendProps = {
            length: 12,
            decimal_places: auto_adapt_places && typeof decimal_places === 'number' ? decimal_places : 6,
            auto_adapt_places,
            type: 'number',
            extra: '%'
        }
        return (
            <div className="form-percentile">
                <NumberElement {...props} {...appendProps}/>
            </div>
        )
    }
}
export default WrapComponent(Percentile);


// WEBPACK FOOTER //
// ./src/component/Number/Percentile.js